var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "infoList",
      style: { width: _vm.info.width, height: _vm.info.width },
    },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("Icon", {
            attrs: {
              type: _vm.info.icon,
              size: _vm.info.size,
              color: _vm.info.color,
              custom: _vm.info.custom,
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.info.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "title-r" }, [
            _c("a", { staticClass: "all", on: { click: _vm.toPromacti } }, [
              _vm._v("更多>>"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.info.infos, function (list, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "list",
            on: {
              click: function ($event) {
                return _vm.toTableClick(list.ID, list.PM_C_PROM_TYPE_ID)
              },
            },
          },
          [
            _c("Icon", {
              staticStyle: { "vertical-align": "top", color: "#666" },
              attrs: { type: "ios-radio-button-on", size: "10" },
            }),
            _vm._v(" "),
            _c("a", { staticClass: "info" }, [_vm._v(_vm._s(list.ENAME))]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }